import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "oka-vtc-privacy-ack";

export default function PrivacyBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      // localStorage indisponible (navigation privée stricte, etc.) : on affiche quand même
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // pas bloquant si le stockage échoue
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="privacy-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#0B132B] text-white/90"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-sm leading-relaxed max-w-2xl">
          Les informations transmises via le formulaire de réservation sont utilisées
          uniquement pour traiter votre demande. Nous n'utilisons aucun cookie de suivi.{" "}
          <Link to="/confidentialite" className="underline hover:text-white">
            En savoir plus
          </Link>
        </p>
        <button
          onClick={dismiss}
          data-testid="privacy-banner-dismiss"
          className="shrink-0 inline-flex items-center gap-2 bg-white text-[#0B132B] px-5 py-2.5 text-sm font-semibold hover:bg-[#8ea2c8] transition-colors duration-300"
        >
          J'ai compris
        </button>
        <button
          onClick={dismiss}
          aria-label="Fermer"
          className="absolute top-2 right-2 md:hidden text-white/60 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
